// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.estrellaDammMug',
  title: 'hardCoded.title.estrelladammBigMug',
  slug: titleToSlug('hardCoded.title.estrelladammBigMug'),
  catalog: {
    title: 'hardCoded.catalog.title.estrellaDammMug',
    catalogMedia,
    price: numberToCurrency('18'),
    color: '#ffffff'
  }
}
